// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"70":"b5d64098","290":"49d4360f"}[chunkId] + ".chunk.css";
};